import type { ShirtColor } from '../types';
import { COLOR_META } from './colors';

/**
 * Buyer-facing reason for a `quota_exceeded` from POST /orders. The server re-derives the
 * allowance under a row lock, so the counts here are fresher than the ones the gate returned.
 */
export function quotaExceededMessage(body: Record<string, unknown>): string {
  const remaining = typeof body.remaining === 'number' ? body.remaining : 0;
  const color =
    typeof body.color === 'string' && body.color in COLOR_META ? (body.color as ShirtColor) : null;
  if (color) {
    const label = COLOR_META[color].label;
    return remaining > 0
      ? `${label}: na to zamówienie możesz dokupić już tylko ${remaining} szt. - zmniejsz koszyk.`
      : `${label}: limit na to zamówienie jest już wykorzystany - usuń te koszulki z koszyka.`;
  }
  return remaining > 0
    ? `Na to zamówienie zostało już tylko ${remaining} koszulek - zmniejsz koszyk.`
    : 'Na to zamówienie kupiono już maksymalną liczbę koszulek.';
}
